import { isMobileDevice } from "src/shared/utils";
import OAuthService from "./oauth.service";

const USER_AVATAR =
  "https://user-images.githubusercontent.com/4329912/66336007-d7006800-e959-11e9-99f2-0ee01a1e8bbc.png";

const AZURE_PROVIDER = "https://login.microsoftonline.com";

export type AuthError = {
  message: string;
};

type PromisedResponseError<R, E = AuthError> = Promise<{
  response?: R;
  error?: E;
}>;

export enum UXType {
  POPUP,
  REDIRECTION,
}

interface IAuthService {
  authenticate: () => PromisedResponseError<string | null>;
  authenticateUsingOAuth: ({ uxType: UXType }) => Promise<string | void>;
  determineOAuthUXType: () => UXType;
  getExistingStoredCredentials: () => PromisedResponseError<CredentialType | null>;
  isCredentialsApiSupported: boolean;
  storeFederatedCredentials?: () => PromisedResponseError<CredentialType>;
}

export class AuthService implements IAuthService {
  public get isCredentialsApiSupported() {
    return Boolean(navigator.credentials && (window as any).FederatedCredential);
  }

  public getExistingStoredCredentials = async () => {
    try {
      const response = await navigator.credentials.get({
        federated: { providers: [AZURE_PROVIDER] },
        mediation: "required",
      });
      return { response };
    } catch (e) {
      console.error("Error while retrieving credentials", e);
      return { error: e as AuthError };
    }
  };

  public async authenticate() {
    // const { response } = await this.getExistingStoredCredentials();
    // if (response != null) {
    //   return { response: (response as FederatedCredential).id };
    // } else {
    const uxType = this.determineOAuthUXType();
    try {
      const response = await this.authenticateUsingOAuth({ uxType });
      if (!response) {
        throw "No message received";
      }
      return { response };
    } catch (e) {
      return { error: { message: e } as AuthError };
    }
    // }
  }

  public determineOAuthUXType() {
    return isMobileDevice() ? UXType.REDIRECTION : UXType.POPUP; // if remove UXType.REDIRECTION in case of mobile, you must allow popup in browser
  }

  public async authenticateUsingOAuth({ uxType }) {
    switch (uxType) {
      case UXType.POPUP: {
        OAuthService.launchPopup();
        return new Promise<string>((resolve, reject) => {
          OAuthService.listenToMessageEvent(resolve, reject);
        });
      }
      case UXType.REDIRECTION: {
        OAuthService.redirectToLogin();
        return Promise.reject("Redirected to Login Page");
      }
      default:
        return Promise.reject("Wrong UXType passed");
    }
  }

  public storeCredentials = async ({ token, name }) => {
    const credentials = new (window as any).FederatedCredential({
      id: token,
      provider: AZURE_PROVIDER,
      name: name,
      iconURL: USER_AVATAR,
    });

    return await navigator.credentials.store(credentials);
  };
}

export default new AuthService();
